// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "a805d4a6e5b01bed6a5e" + ".chunk.js";
};